import * as _ from 'lodash';

// Login Methods from backend/lib/definitions/UserConstants.js
export const LOGIN_METHODS: Record<string, LoginMethod> = {
  EMAIL: 'email',
  SSO: 'SSO',
  BORROWER_SAML: 'borrowerSAML',
  ANONYMOUS_BORROWER: 'anonymousBorrower',
};

const LOGIN_METHOD_TO_URL = {
  [LOGIN_METHODS.EMAIL]: '/',
  [LOGIN_METHODS.SSO]: '/auth/saml',
  [LOGIN_METHODS.BORROWER_SAML]: '/auth/saml/borrower',
  [LOGIN_METHODS.ANONYMOUS_BORROWER]: '/auth/saml/borrower',
};

export function getLoginUrl(loginMethod) {
  if (!_.includes(_.keys(LOGIN_METHOD_TO_URL), loginMethod)) {
    return '/';
  }

  return LOGIN_METHOD_TO_URL[loginMethod];
}
